import React from 'react';
// import Thumb from '../components/Thumb';
// import Comments from '../components/comments/Comments';
import MediaViewer from '../components/MediaViewer';

class MediaViewerPage extends React.Component {

    render() {
        return this.props.match && this.props.match.params && this.props.match.params.mediaId ? (
            <MediaViewer mediaId={this.props.match.params.mediaId} mediaSlug={this.props.match.params.slug} match={this.props.match} isPage={true}/>
        ) : (
            <div></div>
        )
    }
}

export default MediaViewerPage;
